export default "__VITE_ASSET__Bnt0VDKU__"